<template>
  <div>
    <h2 class="ma-4">{{ $t("article") }}</h2>
    <v-card class="ma-2" v-if="isNoArticle">
      <v-card-text>
        <p class="text-md-center">{{ $t("noArticle") }}</p>
      </v-card-text>
    </v-card>
    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="(article) in favedArticles"
          :key="article.id"
          :cols="$vuetify.breakpoint.mdAndUp?4:6"
        >
          <article-card
            class="text-right"
            :id="article.id"
            :title="article.title"
            :img-src="article.imgUrl ? article.imgUrl : '/img/noimage.png'"
            :date="article.date"
          ></article-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ArticleCard from "@/components/ArticleCard.vue";

export default {
  components: {
    ArticleCard
  },
  data() {
    return {};
  },
  metaInfo: {
    title: "Favorites",
    meta: [
      {
        property: "og:type",
        content: "article",
        vmid: "og:type"
      }
    ]
  },
  created() {
    // change i18n locale from path params
    const locale = this.$route.params.locale;
    document.documentElement.lang = locale;
    this.$root.$i18n.locale = locale;
  },
  computed: {
    ...mapState(["favedArticles"]),
    isNoArticle: function() {
      return Object.keys(this.favedArticles).length === 0;
    }
  }
};
</script>

<i18n>
{
  "en": {
    "article": "Favorite articles",
    "noArticle":"You have not favorited any articles."
  },
  "ja": {
    "article": "お気に入りの記事",
    "noArticle":"お気に入り登録された記事はありません"
  }
}
</i18n>

<style scoped>
</style>